import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { isEmpty } from 'lodash'
import get from 'lodash/get'
import React, { useEffect, useState } from 'react'
import {
    useHistory,
    useLocation,
} from 'react-router-dom'
import 'react-table/react-table.css'
import {
    APP_BAR_HEIGHT,
    DEFAULT_LOCATION,
    GET_USER_SESSION,
    VERSION_MISMATCH_ALERT_BANNER_HEIGHT,
} from '../../Constants'
import {
    getUserData,
    setEstimateConfig,
    setDefaultValuationType,
} from '../../Utils/ServerUtil'
import useRequestForServer from '../../Utils/useRequestForServer'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { MainAppBar } from '../MainAppBar'
import ReleaseNotesModal from '../eval/components/VersionNotes'
import useInactivityLogout from '../../Utils/useInactivityLogout'
import LogoutWarningModal from '../eval/components/LogoutWarningModal'
import config from '../../config/runtime'
import { apiService } from '../../services/api'

// Helper function to get background color based on environment
const getEnvironmentBackgroundColor = () => {
    const environment = config.ENVIRONMENT?.toLowerCase() || '';
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    // If running on localhost without explicit environment, treat as dev
    if (isLocalhost && !environment) {
        return '#e6ffe6'; // Light green for dev
    }
    
    console.log({environment})
    
    switch(environment) {
        case 'staging':
            return '#e6ecff'; // Light blue/purple for staging
        case 'devcloud':
        case 'dev':
        case 'development':
            return '#ebfaeb' // Light green for dev
            //return '#e6ecff'; 
            //return '#ffe6ff'; 
        case 'qa':
            return '#ffe6ff'; // Light pink for QA
        case 'prod':
        case 'production':
        default:
            // For production or when running locally without environment
            return isLocalhost ? '#faffe6' : '#f0f2f5'; // Light green for localhost, grey for production
    }
};

const useStyles = makeStyles(
    (theme) => ({
        root: {
            width: '100%',
            backgroundColor: getEnvironmentBackgroundColor(),
            height: '100vh',
            margin: 0,
            '@media print': {
                height: '100%',
            },
        },
        rootWithBanner: {
            width: '100%',
            backgroundColor: getEnvironmentBackgroundColor(),
            height: '100vh',
            margin: 0,
            paddingTop: `${VERSION_MISMATCH_ALERT_BANNER_HEIGHT}px`,
            '@media print': {
                height: '100%',
                paddingTop: 0,
            },
        },
        mainGrid: {
            height: `calc(100% - ${APP_BAR_HEIGHT}px)`,
            margin: '0 auto',
            '@media print': {
                display: 'block',
            },
        },
        mainGridWithBanner: {
            height: `calc(100% - ${APP_BAR_HEIGHT}px - ${VERSION_MISMATCH_ALERT_BANNER_HEIGHT}px)`,
            margin: '0 auto',
            '@media print': {
                display: 'block',
            },
        },
        mainGridFullScreen: {
            height: `100%`,
            margin: '0 auto',
            '@media print': {
                display: 'block',
            },
        },
        button: {
            color: 'inherit !important',
            textTransform: 'none !important',
            fontSize: '18px !important',
            [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(0.5, 0.5),
            },
        },
        titleStyle: {
            fontSize: '14px !important',
            fontWeight: 500,
            lineHeight: '17px',
            textAlign: 'center',
            color: theme.palette.secondary.contrastText,
            textTransform: 'none',
            whiteSpace: 'nowrap',
            [theme.breakpoints.down('xs')]: {
                whiteSpace: 'wrap',
            },
        },
        close: {
            width: theme.spacing(4),
            height: theme.spacing(4),
        },
        list: {
            height: '100%',
            width: '100%',
        },

    }),
    { name: 'AppLayoutStyles' }
);

/**
 * Layout component that provides the main app structure with navigation and content area
 */
export default function AppLayout({ isNewVersionAvailable, children, showAppBar = false }) {
    const classes = useStyles()
    const history = useHistory()
    const location = useLocation()

    const isMobileOrTablet = useMediaQuery('(max-width: 435px)')

    const { isZoomed } = get(location, 'location.state', {})
    const timeout = 30 * 60 * 1000;
    const warningTime = 25 * 60 * 1000;

    const { showWarning, resetTimer, warningDuration } = useInactivityLogout({timeout, warningTime});

    const { loading, error, data } = useRequestForServer({
        uri: GET_USER_SESSION,
    })
    const [isReleaseNotesOpen, setReleaseNotesOpen] = useState(false)

    useEffect(() => {
        if (localStorage.getItem('show_release_notes_after_reload') === 'true') {
            localStorage.removeItem('show_release_notes_after_reload')
            setReleaseNotesOpen(true)
        }
    }, [])

    useEffect(() => {
        if (!isEmpty(data)) {
            setEstimateConfig(data)
            setDefaultValuationType(data)
        }
    }, [data])

    const handleVersionClick = (event) => {
        event.preventDefault()
        event.stopPropagation()
        setReleaseNotesOpen(true)
    }

    const handleCloseReleaseNotes = () => {
        setReleaseNotesOpen(false)
    }

    return (
        <div className={isNewVersionAvailable ? classes.rootWithBanner : classes.root}>
            {showAppBar && (
                <MainAppBar
                    display={
                        get(location, 'state.isZoomed', false)
                            ? 'none'
                            : undefined
                    }
                    onVersionClick={handleVersionClick}
                />
            )}
            <Grid
                container
                className={
                    isZoomed
                        ? classes.mainGridFullScreen
                        : isNewVersionAvailable
                            ? classes.mainGridWithBanner
                            : classes.mainGrid
                }
            >
                {children}
            </Grid>

            <ReleaseNotesModal
                open={isReleaseNotesOpen}
                onClose={handleCloseReleaseNotes}
            />
            
            <LogoutWarningModal
                open={showWarning}
                onClose={resetTimer}
                warningDuration={warningDuration}
                onStayLoggedIn={resetTimer}
            />
        </div>
    )
}